import React from 'react';
import { CatalogCategory, sortedCategories, categoryPath } from './categoryTree';

type CategorySelectProps = {
  categories: CatalogCategory[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
  emptyLabel?: string;
  id?: string;
};

export const CategorySelect: React.FC<CategorySelectProps> = ({
  categories,
  value,
  onChange,
  className,
  emptyLabel,
  id,
}) => (
  <select id={id} className={className} value={value} onChange={event => onChange(event.target.value)}>
    {emptyLabel ? <option value="">{emptyLabel}</option> : null}
    {sortedCategories(categories).map(category => (
      <option key={category.id} value={category.id}>{categoryPath(categories, category.id)}</option>
    ))}
  </select>
);
